import { createComponent as _$createComponent } from "solid-js/web";
import { Route, Router } from "@solidjs/router";
import { render } from "solid-js/web";
import "./app.css";
import { AssetsViewer } from "./routes/Assets.tsx";
import { Career } from "./routes/Career.tsx";
import { Duel } from "./routes/Duel.tsx";
import { Fly } from "./routes/Fly.tsx";
import { Home } from "./routes/Home.tsx";
import { Missions } from "./routes/Missions.tsx";
import { installContextMenuSuppression } from "./shell/context-menu.ts";
import { registerServiceWorker } from "./offline/register-sw.ts";
import { Settings } from "./routes/Settings.tsx";
import { Vcr } from "./routes/Vcr.tsx";
import { ViewAirplanes } from "./routes/ViewAirplanes.tsx";

// First, before the service worker and before the router: the right button is
// both "no browser menu over a cockpit" and, since free look, a *control*, and
// a suppression installed after something that can throw is a suppression that
// sometimes is not there at all. See `shell/context-menu.ts` for the other two
// reasons the one-liner this replaces did not hold.
installContextMenuSuppression(document);
registerServiceWorker();
const root = document.getElementById("app");
if (!root) {
  throw new Error("red-opus: #app root element missing from index.html");
}
render(() => _$createComponent(Router, {
  get children() {
    return [_$createComponent(Route, {
      path: "/",
      component: Home
    }), _$createComponent(Route, {
      path: "/career",
      component: Career
    }), _$createComponent(Route, {
      path: "/missions",
      component: Missions
    }), _$createComponent(Route, {
      path: "/fly",
      component: Fly
    }), _$createComponent(Route, {
      path: "/duel",
      component: Duel
    }), _$createComponent(Route, {
      path: "/vcr",
      component: Vcr
    }), _$createComponent(Route, {
      path: "/settings",
      component: Settings
    }), _$createComponent(Route, {
      path: "/planes",
      component: ViewAirplanes
    }), _$createComponent(Route, {
      path: "/assets",
      component: AssetsViewer
    })];
  }
}), root);